import { DialogActionsProps } from '@material-ui/core/DialogActions';
import DialogActions from '@material-ui/core/DialogActions';
import React from 'react';
import styles from './StyledDialog.module.scss';

export class StyledDialogActions extends React.Component<DialogActionsProps> {
    public static muiName = 'DialogActions';

    public render() {
        const { children, ...otherProps } = this.props;
        const dialogClasses = {
            root: styles.dialogActions
        };

        if (React.Children.count(children))
            return (
                <DialogActions {...otherProps} classes={dialogClasses}>
                    {children}
                </DialogActions>
            );

        return null;
    }
}
